import React, { Component } from 'react';
import { Link, Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { register } from '../../redux/actions';
import {RUNNING, SUCSSES, ERROR} from '../../redux/actions';
const REGISTER_PROCESS = "REGISTER_PROCESS"

/*import { register } from '../../actions/auth';
import { createMessage } from '../../actions/messages';*/

export class Register extends Component {
  state = {
    user: '',
    email: '',
    password1: '',
    password2: '',
  };

  static propTypes = {
    register: PropTypes.func.isRequired,
    isAuthenticated: PropTypes.bool,
  };

  onSubmit = (e) => {
    e.preventDefault();
    const { user, email, password1, password2 } = this.state;
    console.log(`user:${user} email:${email} p1:${password1} p2:${password2}`);
    if (password1 !== password2) {
      /* add a logic to show msg */
      console.log("passwords do not match");
    } else {
      const newUser = {
        user,
        email,
        password1,
        password2,
      };
      this.props.register(newUser, REGISTER_PROCESS);
    }
  };

  onChange = (e) => this.setState({ [e.target.name]: e.target.value });

  render() {
    if (this.props.isAuthenticated) {
      return <Redirect to="/" />;
    }
    const { user, email, password, password2 } = this.state;
    return (
    <div className="row register-fragment border py-5 ">
      <div className="col-md-6 m-auto">
        <div className="card card-body mt-5">
          <h2 className="text-center page-title">Register</h2>
          <form onSubmit={this.onSubmit}>
            <div className="form-group">
              <label>Username</label>
              <input
                type="text"
                className="form-control"
                name="user"
                onChange={this.onChange}
                value={user}
              />
            </div>
            <div className="form-group">
              <label>Email</label>
              <input
                type="email"
                className="form-control"
                name="email"
                onChange={this.onChange}
                value={email}
              />
            </div>
            <div className="form-group">
              <label>Password</label>
              <input
                type="password"
                className="form-control"
                name="password1"
                onChange={this.onChange}
                value={password}
              />
            </div>
            <div className="form-group">
              <label>Confirm Password</label>
              <input
                type="password"
                className="form-control"
                name="password2"
                onChange={this.onChange}
                value={password2}
              />
            </div>
            <div className="form-group">
              {this.props.loginProcessState === ERROR &&
                <div>
                  <ul className="errorList">
                    {this.props.errors&&
                      this.props.errors.map(e=>(
                      <li>
                        {e}
                      </li>
                    ))}
                  </ul>
                </div>
              }
              {this.props.loginProcessState === RUNNING &&
                <div class="spinner-border text-dark" role="status">
                  <span class="sr-only">Registering...</span>
                </div>
              }
              <div>
                <button disabled={this.props.loginProcessState === RUNNING} type="submit" className="btn btn-primary">
                  Register
                </button>
              </div>
            </div>
            <p>
              Already have an account? <Link to="/login">Login</Link>
            </p>
          </form>
        </div>
      </div>
    </div>
    );
  }
}

const mapStateToProps = (state) => ({
  isAuthenticated: state.auth.isAuthenticated,
  loginProcessState: state.processManager.processes[REGISTER_PROCESS],
  errors: state.processManager.errors[REGISTER_PROCESS]
});


export default connect(mapStateToProps, { register })(Register);
